import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'universal-cookie';

import { useAppStore } from '../../../../stores';
import { resetTriggerPricing } from '../../../../utils/DrupalEntityTypes/FloorPlan/FloorPlanHelpers';
import CrmPushStatusMessage from '../../CrmPushStatusMessage';
import SystemMessage from '../../../SystemMessage/SystemMessage';
import { personalizationDataShape } from '../formPropTypes';

const cookies = new Cookies();

const EndPersonalization = ({
  cookieDataDump,
  triggerWelcomeMessage,
  welcomeMessageSaved,
  crmPushStatus,
  closeModal,
}) => {
  const [buttonText, setButtonText] = useState('Copy Link');
  const [welcomeButtonText, setWelcomeButtonText] = useState(
    'Create Welcome Message',
  );

  const setPricingTriggered = useAppStore((state) => state.setPricingTriggered);

  const resident = cookieDataDump;
  const myFavoritesPage = cookieDataDump.my_favorites_page;

  useEffect(() => {
    resetTriggerPricing(setPricingTriggered);

    const savedMessage = cookies.get('welcome_message');
    const favoritesPageMessage = resident?.favorites_page_message;

    if (savedMessage) {
      setWelcomeButtonText('Edit Welcome Message');
    } else if (favoritesPageMessage) {
      cookies.set('welcome_message', favoritesPageMessage, {
        path: '/',
        maxAge: 14400, // 4 hour cookie expiration
        domain: window.location.hostname,
      });
      setWelcomeButtonText('Edit Welcome Message');
    }
  }, [cookieDataDump]);

  const POBBlurbMessage = () => {
    const nameArray = [resident.first_name];
    if (resident.person2_first_name !== '') {
      nameArray.push(resident.person2_first_name);
    }
    const residentNames = nameArray.join(' and ');
    return `${residentNames}'s Personalized Digital Brochure can be accessed by visiting the link below.`;
  };

  const copyLink = () => {
    const input = document.getElementById(
      'personalization__myFavoritesPage-input',
    );
    input.select();
    input.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(input.value);
    setButtonText('Link Copied');
  };

  const handleWelcomeMessageClick = (e) => {
    e.preventDefault();
    if (typeof triggerWelcomeMessage === 'function') {
      triggerWelcomeMessage();
    } else {
      console.error('triggerWelcomeMessage function not provided');
    }
  };

  const noTrackingMyFavoritesPage = `${myFavoritesPage}?ref=admin`;

  return (
    <div data-testid="personalization-step:end">

      <div className="modal__section">
        {(welcomeMessageSaved || crmPushStatus) && (
          <div className="modal__subsection">
            <SystemMessage
              status="success"
              message={welcomeMessageSaved ? 'Your Welcome Message has been saved.' : null}
              testId="welcome-message-saved"
              fading
            />

            <CrmPushStatusMessage pushStatus={crmPushStatus} />
          </div>
        ) }
        <h1 className="modal__subsection modal__title modal__title--short">Personalization is Now Off</h1>
        <div className="modal__subsection modal__description modal__description--short">
          <POBBlurbMessage />
        </div>
      </div>

      <div className="modal__section personalization__pibLink">
        <div className="modal__subsection">
          <input
            defaultValue={myFavoritesPage}
            type="text"
            name="my_favorites_page"
            label="My Favorites Page"
            id="personalization__myFavoritesPage-input"
            tabIndex={-1}
            data-testid="pib-link-input"
          />

          <a
            href={noTrackingMyFavoritesPage}
            target="_blank"
            rel="noopener noreferrer"
            tabIndex={-1}
            data-testid="pib-link"
          >
            {myFavoritesPage || 'No Link Available'}
          </a>
        </div>

        <div className="modal__subsection">
          <button
            type="button"
            className="modal__btn modal__btn--small"
            onClick={copyLink}
            disabled={buttonText === 'Link Copied'}
            data-testid="pib-copy-link"
          >
            {buttonText}
          </button>
        </div>
      </div>

      <div className="modal__section modal__btns modal__btns--inline modal__subsection">

        <button
          type="button"
          className="modal__btn modal__btn--secondary"
          onClick={handleWelcomeMessageClick}
          data-testid="welcome-message-open"
        >
          {welcomeButtonText}
        </button>

        <button
          type="button"
          className="modal__textBtn"
          onClick={() => closeModal()}
        >
          Or Close
        </button>

      </div>
    </div>
  );
};

EndPersonalization.propTypes = {
  cookieDataDump: personalizationDataShape.isRequired,
  triggerWelcomeMessage: PropTypes.func.isRequired,
  welcomeMessageSaved: PropTypes.bool,
  crmPushStatus: PropTypes.shape({
    crm: PropTypes.string,
    pushed: PropTypes.bool,
    items: PropTypes.arrayOf(PropTypes.shape({
      ok: PropTypes.bool,
      message: PropTypes.string,
    })),
  }),
  closeModal: PropTypes.func.isRequired,
};

EndPersonalization.defaultProps = {
  welcomeMessageSaved: false,
  crmPushStatus: null,
};

export default EndPersonalization;
